import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import tabsImg from '../../../assets/images/bet-on-poker/tabs-img.png';

export function ExtraBetsSwitcher({ isCombinations, setIsCombinations }) {
  const t = useTranslation();
  return (
    <div className={`extra-bet-tabs-section ${isCombinations ? 'active' : ''}`}>
      <div className='extra-bet-tabs' onClick={() => setIsCombinations(true)}>
        <img src={tabsImg} alt='#' className='extra-bet-tab-img' />
        <p className='extra-bet-tabs-text'>{t('COMBINATIONS')}</p>
      </div>
      <div className='extra-bet-tabs' onClick={() => setIsCombinations(false)}>
        <img src={tabsImg} alt='#' className='extra-bet-tab-img' />
        <p className='extra-bet-tabs-text'>{t('FLOP_CARDS')}</p>
      </div>
    </div>
  );
}
